import { createAsyncThunk } from '@reduxjs/toolkit';
import inventoryService from '../../../api/services/inventory';

export const getMarketplaceItemInventory = createAsyncThunk('inventory/get-marketplace-item-inventory', async () => {
  return await inventoryService.getMarketplaceItemInventory();
});

export const generateInventoryFile = createAsyncThunk('inventory/generate-inventory-file', async type => {
  return await inventoryService.generateInventoryFile(type);
});
